<div class="aside">
  <div class="aside-header">
    <img id="logo" src="{{ 'assets/images/logo.png' }}" />
  </div>
  <div class="aside-info">
    <div class="user">
      {{user?.username}}
    </div>
    <div class="logout">
      <a (click)="logout()">
        <span class="text-main">{{ 'NAVIGATIONS.LOGOUT' | translate }}</span>
      </a>
    </div>
  </div>
  <nav class="navbar">
    <ul class="nav">
      <li
        *ngFor="let m of menu"
        class="nav-item"
        [ngClass]="{ expanded: m.expanded, 'active': activeUrl.indexOf(m.url) >= 0 }">
        <a
          *ngIf="!m.children"
          class="nav-link link-icon"
          routerLink="{{ m.url }}">
          {{ "NAVIGATIONS." + m.constant | translate }}
        </a>
        <ng-container *ngIf="m.children">
          <a *ngIf="m.constant!=='CMS'"
            class="nav-link link-icon expandable"
            (click)="m.expanded = !m.expanded; expandMenu()">
            {{ "NAVIGATIONS." + m.constant | translate}}
          </a>
          <a *ngIf="m.constant==='CMS'"
          class="nav-link nav-link2 link-icon">
            <div class="w-100" routerLink="{{ m.url }}">{{ "NAVIGATIONS." + m.constant | translate}}</div>
            <i (click)="m.expanded = !m.expanded; expandMenu()" class="nav-link fa fa-angle-right" aria-hidden="true"></i>
          </a>
          <ul class="subnav">
            <li class="subnav-item"
                *ngFor="let sub of m.children"
                [ngClass]="{ expanded: sub.expanded, 'active': activeUrl.indexOf(sub.url) >= 0 }">
              <a
                *ngIf="!sub.children"
                class="subnav-link"
                routerLink="{{ sub.url }}">
                {{ "NAVIGATIONS." + sub.constant | translate }}
              </a>
              <ng-container *ngIf="sub.children">
                <a
                  class="subnav-link expandable"
                  (click)="sub.expanded = !sub.expanded">
                  {{ "NAVIGATIONS." + sub.constant | translate }}
                </a>
                <ul class="nested-subnav">
                  <li *ngFor="let item of sub.children" [ngClass]="{'active': activeUrl.indexOf(item.url) >= 0}">
                    <a class="nav-link" routerLink="{{ item.url }}">{{
                      "NAVIGATIONS." + item.constant | translate
                      }}</a>
                  </li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </ng-container>
      </li>
    </ul>
  </nav>
</div>
